var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiplePages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65625 25.3333V29.3333M2.65625 25.3333H6.65625H2.65625ZM10.6563 25.3333H6.65625H10.6563ZM6.65625 25.3333V21.3333V25.3333Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 2.66667H21.9997L27.9997 8.66667V25.3333",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 29.3333H22C23.1045 29.3333 24 28.4379 24 27.3333V11.6647C24 11.4525 23.9157 11.2491 23.7657 11.099L19.5676 6.90098C19.4176 6.75094 19.2141 6.66666 19.002 6.66666H6C4.89543 6.66666 4 7.56209 4 8.66666V17.3333",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 11.2V7.13806C18.667 6.87772 18.8781 6.66666 19.1385 6.66666C19.2634 6.66666 19.3833 6.71633 19.4718 6.80473L23.8622 11.1953C23.9507 11.2837 24.0003 11.4036 24.0003 11.5286C24.0003 11.7889 23.7893 12 23.5289 12H19.467C19.0251 12 18.667 11.6418 18.667 11.2Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplePages);
export default __webpack_public_path__ + "static/media/multiplePages.833a66d559ae7cc181415038d244e8d0.svg";
export { ForwardRef as ReactComponent };